<div [translatable]="{
    transKey: labelTranslationKey,
    modEnum: labelTranslationModuleEnum
  }">
  <div class="badge-status" [ngClass]="className?.split(' ').join('')" placement="bottom"
    [style.backgroundColor]="backgroundColor" [style.color]="backgroundColor ? 'white':'unset'"
    [ngbTooltip]="rejectReason">
    {{ label | translate }}
  </div>
</div>